import { type SpreadsheetRowId } from '../../../_shared/types/spreadsheetData/spreadsheetRow';

export enum RightSidebarView {
  LocationListing = 'LocationListing',
  MasterKey = 'MasterKey',
  CustomizeLocation = 'CustomizeLocation',
  ProximityDetails = 'ProximityDetails',
  BoundaryDetails = 'BoundaryDetails',
  BoundaryTerritoryDetails = 'BoundaryTerritoryDetails',
  DrawingToolDetails = 'DrawingToolDetails',
  PlaceDetails = 'PlaceDetails',
}

export type ActiveProximity = Readonly<{
  proximityId: string;
  spreadsheetRowId?: SpreadsheetRowId;
}>;

export type RightSidebarConfiguration = ({
  view: RightSidebarView.CustomizeLocation;
  markerId: SpreadsheetRowId;
} | {
  view: RightSidebarView.ProximityDetails;
  activeMetrics: ActiveProximity;
} | {
  view: RightSidebarView.BoundaryDetails;
  boundaryGroupId: number;
  boundaryId: number;
  boundaryTerritoryGroupId: number;
} | {
  boundaryTerritoryGroupId: number;
  boundaryTerritoryId: string;
  view: RightSidebarView.BoundaryTerritoryDetails;
} | {
  view: RightSidebarView.LocationListing;
} | {
  view: RightSidebarView.MasterKey;
} | {
  view: RightSidebarView.DrawingToolDetails;
} | {
  view: RightSidebarView.PlaceDetails;
});

export enum RightSidebarOpeneableApps {
  EditPanel = 'EditPanel',
}
